<tool-drawer-container (openFormDialog)="openDialog()">
  <course-rank-form
    (pendingEmitter)="handlePending($event)"
    class="form-slot"
  ></course-rank-form>

  <tool-header class="tool-header" headerTitle="Course Rank"></tool-header>

  <course-rank-content class="main-content"></course-rank-content>
</tool-drawer-container>
